import { shade, tint } from 'polished';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { Popover } from '../../canvas/ui/Popover';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { AssistantView } from './AssistantView';

const ButtonFrame = styled.div<{ active: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: ${tint(.1, Colors.positive)};
    color: white;
    cursor: pointer;
    user-select: none;

    &:hover {
        background: ${Colors.positive};
    }
    ${p => p.active && css`
        background: ${Colors.positive};
    `}
    &:active {
        background: ${shade(.2, Colors.positive)};
    }
`;

export const AssistantButtonWidget = () => {

    const [open, setOpen] = useState(false);

    return <Flexer margin="0 0 8 0" pointerEvents="none">
        <Flexer pointerEvents="all">
            <Popover
                placement="left-end"
                content={<AssistantView />}
                inner={{ direction: 'left', offset: '1' }}
                open={open}
                onOpenChange={setOpen}
                promptOpts={{
                    ignoreEscape: true,
                    ignoreMouse: true,
                }}
            >
                <ButtonFrame active={false}>
                    <Icon size="2" src="deqo://icons/hero/chip" />
                </ButtonFrame>
            </Popover>
        </Flexer>
    </Flexer>;
};
